/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchReportResponse } from './search-report-response';


export interface SearchReportResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchReportResponse> | null;
}

